import React, { useEffect, useState } from "react";
import "./LoginRegisterRecoverForm.css";
import LoginFormBackend from "./Login/LoginFormBackend";
import { FORM_STEPS } from "../../Utils/Constants";
import { useDispatch } from "react-redux";
import { turnOffLoadingActionCreator } from "../../actions/commonActions";
import { getMenu } from "../../services/services";
import RegisterV2 from "../../../../user/src/Pages/Register/RegisterV2";
import RecoverFormBackend from "./Recover/RecoverFormBackend";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { URL_HOME } from "../../Components/Routes/Location";
import { applyTheme } from "../../Utils/theme";

const LoginRegisterRecoverForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [formStep, setFormStep] = useState(FORM_STEPS.LOGIN);
    const [tenantLanguages, setTenantLanguages] = useState([]);

    const turnOffLoading = () => {
        dispatch(turnOffLoadingActionCreator());
    };

    const getMenuCallback = (data) => {
        setTenantLanguages(data?.languages);
        applyTheme(data);
        turnOffLoading();
    }

    const getMenuErrorCallback = (error) => {
        setTenantLanguages(["es", "en"]);
        turnOffLoading();
    }

    useEffect(() => {
        getMenu(getMenuCallback, getMenuErrorCallback);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleLogin = () => {
        history.push(URL_HOME);
    }

    const handleNavigateAsGuest = () => {
        history.push(URL_HOME);
    }

    return (
        <div className="Page">
            {formStep === FORM_STEPS.LOGIN && (
                <div className="Form">
                    <LoginFormBackend
                        tenantLanguages={tenantLanguages}
                        changeFormStep={setFormStep}
                        handleLogin={handleLogin}
                        handleNavigateAsGuest={handleNavigateAsGuest}
                    />
                </div>
            )}
            {formStep === FORM_STEPS.REGISTER && (
                <RegisterV2 changeFormStep={setFormStep} />
            )}
            {formStep === FORM_STEPS.RECOVER && (
                <>
                    <div className="PageBackground"></div>
                    <div className="Form">
                        <RecoverFormBackend
                            tenantLanguages={tenantLanguages}
                            changeFormStep={setFormStep}
                        />
                    </div>
                </>
            )}
        </div>
    );
};
export default LoginRegisterRecoverForm;
